import { forwardRef, ReactNode } from 'react';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { FaIcon } from '@atoms/icons';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export type CheckboxProps = MuiCheckboxProps & {
  label?: ReactNode;
  onChange?: (event: React.SyntheticEvent, checked: boolean) => void;
  formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'>;
};
export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(function Checkbox(
  { label, onChange, sx, formControlLabelProps, ...props },
  ref,
) {
  const theme = useTheme();

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          ref={ref}
          icon={<FaIcon name="square" color={theme.palette.grey[500]} />}
          checkedIcon={<FaIcon name="square-check" color="primary" />}
          sx={{ m: '3px', ...sx }}
          checked={!!props.value}
          {...props}
        />
      }
      label={
        <Typography
          component={'span'}
          sx={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          color={props.disabled ? theme.palette.action.disabled : undefined}
        >
          {label}
        </Typography>
      }
      onChange={onChange}
      {...formControlLabelProps}
      sx={{
        marginLeft: 0,
        display: 'flex',
        ...formControlLabelProps?.sx,
      }}
    />
  );
});
